export default "__VITE_ASSET__CB5pxGYz__"